import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "antd";
import { RcFile } from "antd/es/upload";
import CheckboxInput from "components/Form/CheckboxInput";
import LabeledInput from "components/Form/LabeledInput";
import LabeledSelectInput from "components/Form/LabeledSelectInput";
import LabeledUploadInput from "components/Form/LabeledUploadInput";
import { IFleetInput } from "models/fleet";
import { IFleetModel } from "models/fleetModel";
import { useForm } from "react-hook-form";
import createFleeValidator from "validators/createFlee.validator";

interface IProps {
  fleetModels: { loading: boolean; data: IFleetModel[] };
  onFleetInfoSubmit: (input: IFleetInput) => void;
  stepper: number;
  handleBackStepper: () => void;
  handleUploadFleetImage: (file: RcFile) => Promise<string | undefined>;
  handleUploadLicenseImage: (file: RcFile) => Promise<string | undefined>;
}

export default function FleetInfoStepper({
  fleetModels,
  onFleetInfoSubmit,
  handleBackStepper,
  handleUploadFleetImage,
  handleUploadLicenseImage,
  stepper,
}: IProps) {
  const { control, handleSubmit } = useForm<IFleetInput>({
    resolver: yupResolver(createFleeValidator),
  });

  return (
    <form
      onSubmit={handleSubmit(onFleetInfoSubmit)}
      className={`w-full ${stepper === 2 ? "flex" : "hidden"} flex-wrap`}
    >
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledInput
          label="Fleet Brand"
          type="text"
          control={control}
          name="brand"
          placeholder="Fleet Brand"
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledInput
          label="Fleet Model"
          type="text"
          control={control}
          name="model"
          placeholder="Fleet Model"
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledInput
          label="Fleet Color"
          type="text"
          control={control}
          name="color"
          placeholder="Fleet Color"
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledSelectInput
          label="Fleet Type"
          control={control}
          loading={fleetModels.loading}
          name="fleet_model_id"
          placeholder="Select Fleet Type"
          options={fleetModels.data.map((value) => ({
            value: value.id,
            label: value.name,
          }))}
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledSelectInput
          label="Fleet Category"
          control={control}
          name="category"
          placeholder="Select Fleet Category"
          options={[
            { label: "Engine", value: "Engine" },
            { label: "EV", value: "EV" },
            { label: "Megala", value: "Megala" },
            { label: "Proto", value: "Proto" },
            { label: "Bajaj", value: "Bajaj" },
            { label: "Proto Megala", value: "Proto Megala" },
            { label: "Megala Engine", value: "Megala Engine" },
            { label: "Megala EV", value: "Megala EV" },
            { label: "Proto Engine", value: "Proto Engine" },
            { label: "Proto EV", value: "Proto EV" },
          ]}
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledInput
          label="Fleet plate number"
          type="text"
          control={control}
          name="plate_number"
          placeholder="Fleet plate number"
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledInput
          label="Fleet license number"
          type="text"
          control={control}
          name="license_number"
          placeholder="Fleet license number"
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledInput
          label="Fleet brand number"
          type="text"
          control={control}
          name="brand_number"
          placeholder="Fleet brand number"
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledInput
          label="Fleet production year"
          type="number"
          min="1980"
          max={new Date().getFullYear()}
          control={control}
          name="production_year"
          placeholder="Fleet production year"
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledInput
          label="Fleet door number"
          type="text"
          control={control}
          name="door_number"
          placeholder="Fleet door number"
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledInput
          label="Fleet passenger seat"
          type="text"
          control={control}
          name="passenger_seat"
          placeholder="Fleet passenger seat"
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledUploadInput
          control={control}
          name="image"
          placeholder="Select Fleet Image"
          label="Fleet Image"
          action={handleUploadFleetImage}
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledUploadInput
          control={control}
          name="license_image"
          placeholder="Select Fleet License Image"
          label="Fleet License Image"
          action={handleUploadLicenseImage}
        />
      </div>
      <div className="w-full px-4 pt-5">
        <CheckboxInput
          control={control}
          name="has_tinted_windows"
          title="Has Tinted Windows"
        />
      </div>
      <div className="w-full px-4 pt-5">
        <CheckboxInput control={control} name="has_ac" title="Has Ac" />
      </div>
      <div className="w-full flex mt-8 justify-between">
        <Button
          onClick={handleBackStepper}
          type="primary"
          className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
        >
          Back
        </Button>
        <Button
          htmlType="submit"
          type="primary"
          className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
        >
          Next
        </Button>
      </div>
    </form>
  );
}
